import React from 'react';

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  hint?: string;
  lang?: 'ar' | 'en';
  required?: boolean;
}

export const FormField = React.forwardRef<HTMLInputElement, FormFieldProps>(
  ({ label, error, hint, lang, required, onChange, style, className, ...props }, ref) => {
    const handleInput: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      if (lang === 'ar') {
        const filtered = e.target.value.replace(/[^؀-ۿݐ-ݿ0-9\s,'.\-#/]/g, '');
        if (filtered !== e.target.value) {
          e.target.value = filtered;
          const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
          setter?.call(e.target, filtered);
          e.target.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
      } else if (lang === 'en') {
        const filtered = e.target.value.replace(/[^a-zA-Z0-9\s,'.\-#/]/g, '');
        if (filtered !== e.target.value) {
          e.target.value = filtered;
          const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
          setter?.call(e.target, filtered);
          e.target.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
      }
      onChange?.(e);
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label className="lbl">
          {label}
          {required && <span style={{ color: 'var(--err)', marginLeft: '2px' }}>*</span>}
        </label>
        <input
          ref={ref}
          data-lang={lang}
          dir={lang === 'ar' ? 'rtl' : 'ltr'}
          onChange={handleInput}
          className={['inp', error ? 'err-inp' : '', className].filter(Boolean).join(' ')}
          style={style}
          {...props}
        />
        {hint && !error && <span className="hint">{hint}</span>}
        {error && <span className="err-msg">{error}</span>}
      </div>
    );
  },
);

FormField.displayName = 'FormField';
